import React from 'react';

export class Selectpowerplant extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selected: false,
      selectedPlant: false,
      basePrice: 0,
      selectedPrice: 0,
      finances: 0,
      subsidy: 0,
      maxSubsidy: 0,
      taxes: 0,
      self: this.props.self,
      selectedEntity: false,
      selectedEntityFunds: false,
      selectedEntityObj: false,
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handlePurchase = this.handlePurchase.bind(this);
    this.handleEntitySelected = this.handleEntitySelected.bind(this);
    this.handleSubsidyChange = this.handleSubsidyChange.bind(this);
  }

  createAlert = (msg) => {
    this.props.createAlert(msg);
  }

  componentWillMount(){
    if(this.props.internal !== false){
      this.setState({
        self: this.props.internal,
      });
    }
  }

  handlePurchase(e){
    e.preventDefault();
    if(this.state.selected !== false) {
      const dataForCallback = {
        name: this.state.selected,
        price: this.state.selectedPrice,
        buyWith: (this.state.selectedEntity === false ? false : this.props.entities[this.state.selectedEntity]),
        marketPrice: this.state.selectedPrice,
        subsidy: (this.state.subsidy === false ? 0 : this.state.subsidy),
        external: false,
        buyer: this.state.self,
      };
      this.props.callbackPurchase(dataForCallback);
    }
  }

  handleSubsidyChange(net) {
    const newSubsidy = net;
    if(newSubsidy > this.state.maxSubsidy) {
      this.createAlert("De overheid heeft maar \u20AC" + this.state.maxSubsidy + " te besteden in deze categorie.");
    } else {
      if ( newSubsidy < 0 ) {
        this.createAlert("Een subsidie mag niet lager zijn dan \u20AC0");
      } else if((this.state.selectedPrice - newSubsidy) < 0){
        this.createAlert("De kostprijs mag niet lager zijn dan \u20AC0");
      } else {
        this.setState({
          subsidy: parseFloat(net, 10)
        });
      }
    }

  }

  handleSelect(e) {
    const index = parseFloat(e.target.value, 10);

    if( !isNaN(index) ){
      let plant = this.state.self.getAvailableServices().find((current) => { return current.id === index});
      const subsidyVal = this.state.self.getApplicableSubsidies(plant.id, "powerPlants", this.props.marine);

      let subsidyPlaceholder = false;
      if(subsidyVal > 0){
        if (subsidyVal > 100) {
          subsidyPlaceholder = 100;
        } else {
          subsidyPlaceholder = subsidyVal;
        }
      }

      this.setState({
        selected: plant.name,
        selectedPlant: plant,
        basePrice: plant.basePrice,
        selectedPrice: plant.basePrice,
        taxes: this.state.self.getApplicableTaxes(parseFloat(index, 10), "powerPlants"),
        maxSubsidy: ( subsidyVal > 0 ? subsidyVal : false ),
        subsidy: subsidyPlaceholder,
      });
    } else {
      this.setState({
        selected: false,
        selectedPlant: false,
        basePrice: 0,
        selectedPrice: 0
      });
    }
  }

  handlePriceChange(net) {
    const newPrice = net;

    if ( newPrice < 0 ){
      this.createAlert("De prijs is te laag, deze moet minimaal 0 zijn");
    } else {
      this.setState({
        selectedPrice: newPrice
      });
    }

  }

  loadOptions = () => {
    let selects = [];
    if(this.state.self === false || this.state.self === undefined) {
      selects.push(<option disabled="true" key="_-1" defaultValue="true">Kies eerst een koper</option>);
    } else {
      selects.push(<option key="_-1" defaultValue="true">Selecteer een energiecentrale om te kopen</option>);

      let plants = this.state.self.getAvailableServices();
      for (let i = 0; i < plants.length; i++) {
        selects.push(
          <option
            key={"_"+i}
            value={plants[i].id}>
              {plants[i].name} |
              {plants[i].mwu} mwu
          </option>
        );
      }
    }

    return selects;
  };

  getEntities(){
    const entities = this.props.entities;

    let entitiesArray = [];
    for (var i = 0; i < entities.length; i++) {
      if(entities[i].type === "city" || entities[i].type === "company"){
        entitiesArray.push(
          <option key={"ent_" + i} value={i}>{entities[i].name}</option>
        );
      }
    }
    return entitiesArray;
  }

  handleEntitySelected(e){
    if (e.target.value === "Koop alleen") {
      this.setState({
        selectedEntity: false,
        selectedEntityFunds: false,
        selectedEntityObj: false,
      })
    } else {
      let entities = this.props.entities;
      let selected = entities[e.target.value];
      let funds  = selected.funds;
      this.setState({
        selectedEntity: e.target.value,
        selectedEntityFunds: funds,
        selectedEntityObj: selected,
      })
    }
  }

  setBuyer = (e) => {
    if(e.target.value === "null" || e.target.value === undefined){
      this.setState({
        self: false,
      });
    } else {
      let entities = this.props.entities;
      let selected = entities.findIndex((current) => {return current.name === e.target.value});
      this.setState({
        self: entities[selected],
      });
    }
  }

  getMutualPrice = () => {
    if(this.props.supplier && this.state.selectedEntity !== false){
      return (
        <div className="invisiWrap">
          <label>Prijs per speler</label>
          <div className="formInputDouble">
            <input type='text' value={(this.state.selectedPrice - this.state.subsidy + this.state.taxes) / 2} readOnly="true"/>
          </div>
        </div>
      )
    }
  };

  getExternal = () => {
    return (
      <div className="formRow">
        <label>Type centrale</label>
        <select className="selectExtCentral" onChange={this.handleSelect}>
          {this.loadOptions()}
        </select>
      </div>
    );
  }

  getSuppliers = () => {
    if(this.props.internal === false){
      let entities = this.props.entities;
      let suppliers = entities.filter((current) => { return current.type === 'supplier'});

      let options = [];

      for (var i = 0; i < suppliers.length; i++) {
        options.push(
          <option key={"ent_" + i} value={suppliers[i].name}>{suppliers[i].name}</option>
        );
      }

      if(this.state.self) {
        var style = {
          backgroundColor: this.state.self.color,
          color: 'rgba(255,255,255)'
        };
      }

      return (
        <div className="selectDouble">
          <label>Koper centrale</label>
          <select onChange={this.setBuyer} style={style}>
            <option value="null">Koop als</option>
            {options}
          </select>
        </div>
      );
    }
  }

  getMutualBuy = () => {
    if(this.props.internal === false && this.props.supplier && this.props.external){

      if(this.state.selectedEntityObj) {
        var style = {
          backgroundColor: this.state.selectedEntityObj.color,
          color: 'rgba(255,255,255)'
        };
      }
      return (
        <div className="selectDouble">
          <label>Samen met</label>
          <select onChange={this.handleEntitySelected} style={style}>
            <option val="false">Koop alleen</option>
            {this.getEntities()}
          </select>
        </div>
      )
    }
  };

  changeVal = (field, amount) => {
    if (field === "price") {
      const newVal = this.state.selectedPrice + amount
      this.handlePriceChange(newVal);
    } else if(field === "subsidy") {
      const newVal = this.state.subsidy + amount;
      this.handleSubsidyChange(newVal);
    }
  }

  getSelectedEntityFunds = () => {
    if(this.state.selectedEntityFunds !== false){
      return (
        <div className="formRow">
          <label>Budget van je partner (&euro;)</label>
          <div className="formInputDouble">
            <input type='text' value={Math.floor(this.state.selectedEntityFunds)} readOnly="true"/>
          </div>
        </div>
      )
    }
  }

  getNewValue = (type, oldVal) => {
    if(type === 'prod'){
      let additionalVal = (this.state.selectedEntityObj !== false ? this.state.selectedPlant.mwu / 2 : this.state.selectedPlant.mwu);
      return parseFloat(oldVal, 10) + parseFloat(additionalVal, 10);
    } else if(type === "green") {
      if(this.state.selectedPlant === false){
        return 0;
      }
      const object = oldVal;
      const previousData = object.getExpensesGreen();

      const greenF = parseFloat(previousData.percentageGreen, 10) / 100;
      const totalMwu = object.getMwuServices() + object.purchasedMwu.reduce((total, cur) => {return total + cur.mwu}, 0);

      const greenMwu = Math.floor(totalMwu * greenF);

      const extraMwu = (this.state.selectedEntity === false ? this.state.selectedPlant.mwu : this.state.selectedPlant.mwu / 2);

      const newGreenMwu = (this.state.selectedPlant !== false && this.state.selectedPlant.green ? greenMwu + extraMwu : greenMwu);
      const newTotalMwu = totalMwu + extraMwu;

      const result = (newGreenMwu / newTotalMwu) * 100;
      if(result > 100){
        return 100;
      } else if(result < 0){
        return 0;
      } else {
        return result.toFixed(0);
      }
    }
  }

  getEntityTable = () => {
    if(this.props.internal === false){
      return (<table className="purchaseComparison">
        <thead>
          <tr><td colSpan="3">{(this.state.selectedEntityObj !== false ? this.state.selectedEntityObj.name : "Kies een koper")}</td></tr>
        </thead>
        <tbody>
          <tr>
            <td>Elektriciteitsvoorziening</td>
            <td className="value value--fade">{(this.state.selectedEntityObj !== false ? this.state.selectedEntityObj.getMwuServices().toFixed(0) : 0)}</td>
            <td className="value value--light-backdrop">{(this.state.selectedEntityObj !== false && this.state.selected !== false ? this.getNewValue("prod", this.state.selectedEntityObj.getMwuServices().toFixed(0)) : 0)}</td>
            <td>MWU</td>
          </tr>
          <tr>
            <td>Duurzaam</td>
            <td className="value value--fade">{(this.state.selectedEntityObj !== false ? this.state.selectedEntityObj.getPercentageGreen().toFixed(0) : 0)}</td>
            <td className="value value--light-backdrop">{(this.state.selectedEntityObj !== false && this.state.selected !== false ? this.getNewValue("green", this.state.selectedEntityObj) : 0)}</td>
            <td>%</td>
          </tr>
          <tr>
            <td>Fossiel</td>
            <td className="value value--fade">{(this.state.selectedEntityObj !== false ? 100 - this.state.selectedEntityObj.getPercentageGreen().toFixed(0) : 0)}</td>
            <td className="value value--light-backdrop">{(this.state.selectedEntityObj !== false && this.state.selected !== false ? 100 - this.getNewValue("green", this.state.selectedEntityObj) : 0)}</td>
            <td>%</td>
          </tr>
        </tbody>
      </table>);
    }
  }

  getStatsTable = () => {
    if(this.props.internal === false){
      return (
        <div className="row">
          <div className="col col--data col--data-small">
            <table className="purchaseComparison">
              <thead>
                <tr><td colSpan="3">{(this.state.self !== false ? this.state.self.name : "Kies een koper")}</td></tr>
              </thead>
              <tbody>
                <tr>
                  <td>Elektriciteitsvoorziening</td>
                  <td className="value value--fade">{(this.state.self !== false ? this.state.self.getMwuServices().toFixed(0) : 0)}</td>
                  <td className="value value--light-backdrop">{(this.state.selected !== false ? this.getNewValue("prod", this.state.self.getMwuServices().toFixed(0)) : 0)}</td>
                  <td>MWU</td>
                </tr>
                <tr>
                  <td>Duurzaam</td>
                  <td className="value value--fade">{(this.state.self !== false ? this.state.self.getPercentageGreen().toFixed(0) : 0)}</td>
                  <td className="value value--light-backdrop">{(this.state.selected !== false ? this.getNewValue("green", this.state.self) : 0)}</td>
                  <td>%</td>
                </tr>
                <tr>
                  <td>Fossiel</td>
                  <td className="value value--fade">{(this.state.self !== false ? 100 - this.state.self.getPercentageGreen().toFixed(0) : 0)}</td>
                  <td className="value value--light-backdrop">{(this.state.selected !== false ? 100 - this.getNewValue("green", this.state.self) : 0)}</td>
                  <td>%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col col--data col--data-small">
            {this.getEntityTable()}
          </div>
        </div>
      )
    } else {
      let mwuBlack = 0;
      if(this.state.self.getExpensesGreen().allMwuBlack + this.state.self.getExpensesGreen().allMwuGreen !== 0){
        mwuBlack = (100 - this.state.self.getExpensesGreen().percentageGreen);
      }

      const mwuGreen = this.state.self.getExpensesGreen().percentageGreen;
      return (
        <div className="row">
          <div className="col col--data col--data-small">
            <table className="purchaseComparison">
              <thead>
                <tr><td colSpan="3">Oude situatie</td></tr>
              </thead>
              <tbody>
                <tr>
                  <td>Elektriciteitsvoorziening</td>
                  <td className="value">{(this.state.self !== false ? this.state.self.getMwuServices().toFixed(0) : 0)}</td>
                  <td>MWU</td>
                </tr>
                <tr>
                  <td>Duurzaam</td>
                  <td className="value">{(this.state.self !== false ? mwuGreen.toFixed(0) : 0)}</td>
                  <td>%</td>
                </tr>
                <tr>
                  <td>Fossiel</td>
                  <td className="value">{(this.state.self !== false ? mwuBlack.toFixed(0) : 0)}</td>
                  <td>%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col col--data col--data-small">
            <table className="purchaseComparison">
              <thead>
                <tr><td colSpan="3">Nieuwe situatie</td></tr>
              </thead>
              <tbody>
                <tr>
                  <td>Elektriciteitsvoorziening</td>
                  <td className="value">{(this.state.selected !== false ? this.getNewValue("prod", this.state.self.getMwuServices().toFixed(0)) : 0)}</td>
                  <td>MWU</td>
                </tr>
                <tr>
                  <td>Duurzaam</td>
                  <td className="value">{(this.state.selected !== false ? this.getNewValue("green", this.state.self) : 0)}</td>
                  <td>%</td>
                </tr>
                <tr>
                  <td>Fossiel</td>
                  <td className="value">{(this.state.selected !== false ? (100 - this.getNewValue("green", this.state.self)) : 0)}</td>
                  <td>%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }


  render(){
    if (this.props.external === "true") {
      return (
        <div>
          {this.getStatsTable()}
          <div className="row">
            <form>
              <div className="formRow">
                {this.getSuppliers()}
                {this.getMutualBuy()}
              </div>
              {this.getExternal()}
              <div className="formRow">
                <label>Prijs (&euro;)</label>
                <div className="formInputNum formInputNum-3col">
                  <input type='text' readOnly="true" onChange={this.handlePriceChange} value={this.state.selectedPrice}/>
                  <div onClick={() => this.changeVal("price", -10)} className="formModifier formModifier--desc"></div>
                  <div onClick={() => this.changeVal("price", 10)} className="formModifier formModifier--asc"></div>
                </div>

                <label className={(this.state.taxes === 0 || !this.state.taxes ? "field-hidden" : "")}>Belasting</label>
                <div className={"formInputNum formInputNum-3col" + (this.state.taxes === 0 || !this.state.taxes ? " field-hidden" : "")}>
                  <input type='text' value={this.state.taxes} readOnly="true"/>
                </div>

                <label className={(this.state.subsidy === 0 || !this.state.subsidy ? "field-hidden" : "")}>Subsidie</label>
                <div className={"formInputNum formInputNum-3col" + (this.state.subsidy === 0 || !this.state.subsidy ? " field-hidden" : "")}>
                  <input type="text" readOnly="true" onChange={this.handleSubsidyChange} value={(this.state.subsidy === false ? 0 : this.state.subsidy)}/>
                  <div onClick={() => this.changeVal("subsidy", -10)} className="formModifier formModifier--desc"></div>
                  <div onClick={() => this.changeVal("subsidy", 10)} className="formModifier formModifier--asc"></div>
                </div>
              </div>
              <div className="formRow">
                <label>Kosten (&euro;)</label>
                <div className="formInputDouble">
                  <input type='text' value={this.state.selectedPrice - this.state.subsidy + this.state.taxes} readOnly="true"/>
                </div>

                <label>Budget (&euro;)</label>
                <div className="formInputDouble">
                  <input type='text' value={(this.state.self === false ? "" : Math.floor(this.state.self.funds))} readOnly="true"/>
                </div>
              </div>

              {this.getSelectedEntityFunds()}

              <div className="dealButton" onClick={this.handlePurchase}>
                <img alt="dealButton" src={require("../../assets/elements/Icon - deal.svg")}/>
                <div className="text">Sluit deal!</div>
              </div>
            </form>
          </div>
        </div>
      )
    } else {
      return (
        <form>
          <select onChange={this.handleSelect}>
            {this.loadOptions()}
          </select>
          {this.getMutualBuy()}
          <label>
            Subsidies:
            <input type="number" step="1" onChange={this.handleSubsidyChange} value={this.state.subsidy}/>
          </label>
          <label>
            Belasting:
            <p>{this.state.taxes}</p>
          </label>
          <label>
            Marktprijs:
            <input type="number" step="10" onChange={this.handlePriceChange} value={this.state.selectedPrice}/>
          </label>

          <label>
            Totaalprijs:
            <p>{this.state.selectedPrice - this.state.subsidy + this.state.taxes}</p>
          </label>

          {this.getMutualPrice()}
          <button onClick={this.handlePurchase}>Koop!</button>
        </form>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/interactive/selectPowerplant.js